import { useCallback, useReducer } from 'react';
import { useLocalStorage } from 'react-use';
import { actionTypesOfReasonForVisit } from 'reducer/actionType';

export const REASON_FOR_VISIT_KEY = 'populate_reasonForVisit';

export type WhatTreatmentsItemWithText = {
  name: string;
  text: string;
};

export type StateTypeOfReasonForVisit = {
  name: string;
  title: string;
  value: string[] | string;
  image?: string;
  text?: string;
  painRate?: number | string;
  options?: WhatTreatmentsItemWithText[];
};

export type ActiveTypeOfReasonForVisit = {
  type: string;
  name: string;
  value: string[] | string;
  image?: string;
  text?: string;
  painRate?: number | string;
  options?: WhatTreatmentsItemWithText[];
};

export const initialState: StateTypeOfReasonForVisit[] = [
  {
    name: actionTypesOfReasonForVisit.REASON_FOR_VISIT,
    title: 'Reason for visit',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.REASON_FOR_VISIT_CONT,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.WHICH_FOOT,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.SHOE_SIZE,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.WHERE_ON_THE_FOOT,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.DIAGNOSIS_UPLOAD_PHOTO,
    title: '',
    value: '',
  },
  {
    name: actionTypesOfReasonForVisit.HOW_LONG_EXPERIENCING_PROBLEM,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.CONSISTENTLY_OR_OFF_PROBLEM,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.HOW_DID_IT_START,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_TYPE_OF_PAIN,
    title: '',
    value: [],
    text: '',
    painRate: '0',
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_ARE_YOUR_SYMPTOMS,
    title: '',
    value: [],
    text: '',
  },
  {
    name: actionTypesOfReasonForVisit.PAIN_WORST,
    title: '',
    value: [],
    text: '',
  },
  {
    name: actionTypesOfReasonForVisit.WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.TREATMENTS_TRIED_HOME,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.SEEN_OTHER_PROVIDERS,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_TREATMENTS_DID_PROVIDER,
    title: '',
    value: [],
    options: [],
  },
  {
    name: actionTypesOfReasonForVisit.HOW_LONG_DID_PHYSICAL_THERAPY,
    title: '',
    value: [],
  },
  {
    name: actionTypesOfReasonForVisit.WHAT_TREATMENTS_WERE_HELPFUL,
    title: '',
    value: [],
  },
];

const reducer = (state: any, action: ActiveTypeOfReasonForVisit) => {
  switch (action.type) {
    default:
      return state.map((data: StateTypeOfReasonForVisit) => {
        if (data.name === action.type) {
          if (action.text && action.painRate) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              text: action.text,
              painRate: action.painRate,
            };
          } if (action.painRate) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              painRate: action.painRate,
            };
          } if (action.text) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              text: action.text,
            };
          } if (action.options) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              options: action.options,
            };
          } if (action.image) {
            return {
              ...data,
              title: action.name,
              value: action.value,
              image: action.image,
            };
          }
          return { ...data, title: action.name, value: action.value };
        } return data;
      });
  }
};

export const usePersistRFVReducer: any = () => {
  const [savedState, saveState] = useLocalStorage(
    REASON_FOR_VISIT_KEY,
    initialState,
  );

  const reducerLocalStorage: any = useCallback(
    // give `reducerLocalStorage` the same TS API
    // as the underlying `reducer` function
    (
      state: StateTypeOfReasonForVisit[],
      action: ActiveTypeOfReasonForVisit,
    ): StateTypeOfReasonForVisit[] => {
      const newState = reducer(state, action);

      saveState(newState);

      return newState;
    },
    [saveState],
  );

  return useReducer(reducerLocalStorage, savedState);
};

export const useClearLocalStorage = () => useLocalStorage(REASON_FOR_VISIT_KEY);
